import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './personalArea.json';

const queryProductType = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['personalAreaController/queryProductType'].success.default)));
};

const initPersonalInfoPage = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['personalAreaController/initPersonalInfoPage'].success.default)));
  };
const queryInstantServiceUsage = (req, res, ctx) => {
  const responseData = apiResponses['personalAreaController/queryInstantServiceUsage'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('personalAreaController/queryProductType'), withScenario(withAuthCheck(queryProductType))),
  rest.post(getApiEndpoint('personalAreaController/initPersonalInfoPage'),withScenario(withAuthCheck(initPersonalInfoPage))),
  rest.post(getApiEndpoint('personalAreaController/queryInstantServiceUsage'),withScenario(withAuthCheck(queryInstantServiceUsage))),
];
